import React from 'react';
import { observer } from 'mobx-react';
import {
  BrowserRouter as Router, RouteComponentProps, Switch, Route
} from "react-router-dom";
import IndexBills from './IndexBills';
import Issuer from './Issuer';
import DownloadFacturas from './DownloadFacturas';
import MonthlyFacturas from './MonthlyFacturas';


interface BillsProps extends RouteComponentProps {
  changeToggle(action?: boolean): void
}

@observer export default class Bills extends React.Component<BillsProps> {
  render() {
    return (
      <Router>
        <Switch>
          <Route
            exact
            path="/facturas"
            render={(props) => (
              <IndexBills {...props} changeToggle={this.props.changeToggle} />
            )}
          ></Route>
          <Route
            exact
            path="/facturas/emisor"
            render={(props) => (
              <Issuer {...props} changeToggle={this.props.changeToggle} />
            )}
          ></Route>
          <Route
            exact
            path="/facturas/descargar"
            render={(props) => (
              <DownloadFacturas {...props} changeToggle={this.props.changeToggle} />
            )}
          ></Route>
          <Route
            exact
            path="/facturas/mes"
            render={(props) => (
              <MonthlyFacturas {...props} changeToggle={this.props.changeToggle} />
            )}
          ></Route>
        </Switch>
      </Router>
    );
  }
}